import { Component, OnInit } from '@angular/core';
import { Application } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Search } from '../../shared/user.model';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-bundles',
  templateUrl: './appretRequest.component.html',
  styleUrls: ['./appretRequest.component.css']
})
export class AppRetRequestComponent implements OnInit {

  s: Search;
  data : any = {};
  applicationlist : any = {};
  applicantionmoredetails : any = [];
  color : number = 0
  godownmaxDetails : any = [];
  GodownBundleNo : number = 0;
  GodownSerialNo : number = 0;
  BundleForm :any = [];
  userForm : NgForm;
  rr : any = {};
  CaseWorkerUserslist : any = {};
  disabled : boolean = false;
  BundleList : any = {};
  mode : string = '';
  mode2 : string = '';
  refundlist : any = [];
  disableCancelation : boolean = true;
  insertdata : boolean = false;
  updatedata : boolean = false;
  allocationStatus : string = '';
  disableSave : boolean = false;
  submission : boolean = false;
 disableupdate : boolean = false;
 formInvalid : boolean = false;
 likeOperator : boolean = false;
 disa1 : boolean = false;
 disa2 : boolean = false;
 

  
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute,private errorHandler: ErrorHandler,
    private formBuilder:ReactiveFormsModule, private fb : FormBuilder ) { 
    this.s = new Search();
  }

  ngOnInit() {    
    this.DefaultData()
  }
  
  DefaultData(){
    this.userService.GetCaseWorkerList()
    .subscribe(
      (data:any) =>{            
        this.CaseWorkerUserslist = data.Result;  
        console.log('Case Worker Users');
        console.log(this.CaseWorkerUserslist);     
        document.getElementById('loader-spinner').style.display = "none";                      
      }
    )  
  }

  onSearch(s) {
    this.mode = '';
    this.color = 0;  
    this.applicantionmoredetails = [];
    this.BundleList = [];
    document.getElementById('loader-spinner').style.display = "block";
    var searchText = this.s.SearchText;
     var searchCriteria = this.s.SearchCriteria;
     if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
       swal("Warning!", "Please enter the searchby  and search text.", "warning");
    else
     {    
      if(this.likeOperator == true)             
      {               
         this.userService.GetApplicationGodownlistForReturnRequest(searchCriteria,searchText)
         .subscribe(
           (data:any) =>{            
             this.applicationlist = data.Result; 
             document.getElementById('loader-spinner').style.display = "none";                      
           }, (error) => {         
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          }
         )   
      }
      else{
        this.userService.GetApplicationGodownlistForReturnRequestonEqual(searchCriteria,searchText)
         .subscribe(
           (data:any) =>{            
             this.applicationlist = data.Result; 
             document.getElementById('loader-spinner').style.display = "none";                      
           }, (error) => {         
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          }
         )  
      }        
    
     }
   }

   GetMoreDetails(Id){
    this.mode = ''; 
    this.mode2 = '';
    this.rr = [];
    this.disableCancelation = false;   
    this.disableSave = false;   
    this.submission = false;
    this.disableupdate = false;
    this.disa2 = false;
    this.disa1 = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.color = Id
     for(let i=0; i<this.applicationlist.length; i++){
       if(Id == this.applicationlist[i].APP_Id){
         this.applicantionmoredetails = this.applicationlist[i];
         
         this.allocationStatus = this.applicantionmoredetails.APP_Status;         
         
         var array = this.allocationStatus.split(" ").slice(-1);         
         this.allocationStatus = array[0];
        
        //  if(this.allocationStatus == 'Refunded'){
        //   this.disabled = false;  
        //   this.GetRefundRequest(this.applicantionmoredetails.APP_Reg_No) ;  
        //  }

         //Commented on 17/03/2021
        //  if(this.applicantionmoredetails.ReturnRequestStatus == this.applicantionmoredetails.APP_Reg_No) {
        //    this.disabled = false;  
        //    this.GetRefundRequest(this.applicantionmoredetails.APP_Reg_No) ;        
        //  }  
         //Commented on 17/03/2021

         //Latest after 17/03/2021
        if((this.applicantionmoredetails.ReturnRequestStatus == this.applicantionmoredetails.APP_Reg_No)&&(this.applicantionmoredetails.SubmitedDate != null)) {
          this.disabled = false;  
           this.GetRefundRequest(this.applicantionmoredetails.APP_Reg_No) ; 
           this.applicantionmoredetails.ReturnRequestStatus="Application  submitted";
         } 
          if((this.applicantionmoredetails.ReturnRequestStatus == this.applicantionmoredetails.APP_Reg_No)&&(this.applicantionmoredetails.SubmitedDate == null)) {
          this.disabled = false;  
           this.GetRefundRequest(this.applicantionmoredetails.APP_Reg_No) ; 
           this.applicantionmoredetails.ReturnRequestStatus="Application  requested but not   submitted";
         }
         //Latest after 17/03/2021
         
         this.getAllBundleList(this.applicantionmoredetails.APP_Reg_No)
         document.getElementById('loader-spinner').style.display = "none";            
       }
     }     
   }

   

   Save(RefundRequest:NgForm){  
    this.disa1 = true;
    if(RefundRequest.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
    else{
      RefundRequest.value.RegNo = this.applicantionmoredetails.APP_Reg_No
     RefundRequest.value.ApplNo = this.applicantionmoredetails.APP_M_App_No;    
    
     this.data = this.userService.PostRefundRequest(RefundRequest.value);    
    this.data.subscribe(
      (response) => {    
        //RefundRequest.reset();           
        swal('Success!', 'Refund Request Added Successfully .', 'success');       
        document.getElementById('loader-spinner').style.display = "none"; 
        // this.color = 0;  
        // this.applicantionmoredetails = [];
        // this.BundleList = []; 
        // this.applicationlist = [];         
        //this.disableSave = true;
        this.submission  =true;
        this.formInvalid = false;  
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
    }   
     
   }

   ///Update only

   UpdateInsertedData(RefundRequest:NgForm){  
    this.disa1 = true;
    if(RefundRequest.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
    else{
      RefundRequest.value.RegNo = this.applicantionmoredetails.APP_Reg_No
     RefundRequest.value.ApplNo = this.applicantionmoredetails.APP_M_App_No;    
    
     this.data = this.userService.Update_Refund_Request_insertData(RefundRequest.value);    
    this.data.subscribe(
      (response) => {    
        //RefundRequest.reset();           
        swal('Success!', 'Refund Request Updated Successfully .', 'success');       
        document.getElementById('loader-spinner').style.display = "none"; 
        this.color = 0;  
        this.applicantionmoredetails = [];
        this.BundleList = []; 
        this.applicationlist = []; 
        this.rr = [];  
        this.formInvalid = false; 
        this.insertdata = false;
        this.updatedata = false;           
       // this.disableSave = true;
        this.submission  =true;
        this.formInvalid = false;  
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
    }   
     
   }


   update(RefundRequest:NgForm){  
    this.disa2 = false;
    if(RefundRequest.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
    else{
      RefundRequest.value.RegNo = this.applicantionmoredetails.APP_Reg_No
    RefundRequest.value.ApplNo = this.applicantionmoredetails.APP_M_App_No;    
   
    this.data = this.userService.UpdateRefundRequest(RefundRequest.value);    
   this.data.subscribe(
     (response) => {    
       RefundRequest.reset();           
       swal('Success!', 'Refund Request Updated Successfully .', 'success');       
       document.getElementById('loader-spinner').style.display = "none"; 
       this.color = 0;  
       this.applicantionmoredetails = [];
       this.BundleList = []; 
       this.applicationlist = []; 
       this.rr = [];  
       this.formInvalid = false; 
       this.insertdata = false;
       this.updatedata = false;     
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });
    }    
  }

   //Bundled data
   getAllBundleList(RegNo){
    this.userService.GetAllBundleList(RegNo)
    .subscribe(
      (data:any) =>{            
        this.BundleList = data.Result;                      
      }
    )  
  }

  //Refundrequest Data
  GetRefundRequest(RegNo){
    this.mode = ''; 
    this.mode2 = '';
    this.disableCancelation =  true;
    this.userService.GetRefundRequest(RegNo)
    .subscribe(
      (data:any) =>{  
        this.refundlist = data     
        this.rr = data;       
        if(this.refundlist != []){
          this.mode = 'View'; 
          this.disableCancelation = false;  
         // this.disableSave = true;      
        }

        if ((this.rr.SubmitedDate != null) && (this.rr.SubmitedTo != null))
        {
          this.mode2 = 'View2';
         // this.disableupdate = true;
        }
        
       
        if (this.rr.RequestDate != null)
        this.rr.RequestDate = ((this.rr.RequestDate).split('T'))[0]; 
        
        if (this.rr.SubmitedDate != null)
        this.rr.SubmitedDate = ((this.rr.SubmitedDate).split('T'))[0]; 
      }) 
   }


   CancelRefundRequest(RegNo)
   {
     swal({
      title: 'Are you sure?', text: "You want to Cancel Refund Request!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, cancel it!'
   }).then((result) => {
     if (result.value) {
    this.userService.CancellationRefundRequest(RegNo)
    .subscribe(
      (data:any) =>{       
        this.disableCancelation = true;
        swal('Success!', 'Refund Request Cancelled Successfully .', 'success');
        this.color = 0;  
        this.applicantionmoredetails = [];
        this.BundleList = []; 
        this.rr = [];
        
      })      
    }
   })
  }

  Insert(){   
    this.insertdata = true;
    this.updatedata = false;
  }
  Update(){   
    this.insertdata = false;
    this.updatedata = true;
  }

  handleChange(evt) {    
    var target = evt.target;
    if (target.checked) {
     this.likeOperator = true
    } else {
      this.likeOperator = false;
    }
  }
}
  






// WEBPACK FOOTER //
// ./src/app/Godown/appretRequest/appretRequest.component.ts